import { useAtom } from 'jotai';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { authorizationPendingAtom, authorizedAtom, checkAuth, setAuthData } from './lib';
import useSsoLogin from './useSsoLogin';

function useAuthorization() {
  const [isAuthorized] = useAtom(authorizedAtom);
  const [, setIsAuthorizationPending] = useAtom(authorizationPendingAtom);
  const { mutate: ssoLogin } = useSsoLogin();

  useEffect(() => {
    if (window.location.search.includes('auth_token')) {
      if (window.location.origin.includes('localhost')) {
        setIsAuthorizationPending(true);
        try {
          const params = new URLSearchParams(window.location.search);
          const token = params.get('auth_token');
          const refreshToken = params.get('refresh_token');

          if (token) {
            setAuthData(token, refreshToken);
          }
        } catch (_error) {
          toast.error('Failed to authorize, please try again later');
        } finally {
          setIsAuthorizationPending(false);
        }
      }

      window.history.replaceState(null, '', window.location.pathname);
    }
  }, [setIsAuthorizationPending]);

  useEffect(() => {
    if (!checkAuth()) {
      ssoLogin();
    }
  }, [ssoLogin, isAuthorized]);
}

export default useAuthorization;
